<section class="l-flex l-column l-deashboard--gallery">
    <button class="save_patieont" (click)="assign()" *ngIf="inbox" style="margin-top: -2em;">
        Assign To this Exam
    </button>
    <ul class="t-menu" style="justify-content: space-between;">
        <div style="display: inline-flex;">
        <li *ngIf="! forPrint && ! gs.showSelect">
            <button class="t-menu-item is-active">
                All ({{imgct+clipct}})
            </button>
        </li>
        <li *ngIf="view !='Timeline'">
            <button class="t-menu-item">
                Images ({{imgct}})
            </button>
        </li>
        <li *ngIf="! forPrint && ! gs.showSelect && view !='Timeline'">
            <button class="t-menu-item">
                Clips ({{clipct}})
            </button>
        </li>
        <li *ngIf="! forPrint && ! gs.showSelect && view !='Timeline'">
            <button class="t-menu-item">
                PDFs ({{pdfct}})
            </button>
        </li>
        <li *ngIf="! forPrint && ! gs.showSelect && view !='Timeline'">
            <button class="t-menu-item" (click)="gs.showSelect = !gs.showSelect">
                Select For Download
            </button>
        </li>
        <li *ngIf="forPrint || gs.showSelect">
            <button class="t-menu-item" (click)="selectAllImages(true)">
                Select All
            </button>
        </li>
        <li *ngIf="forPrint || gs.showSelect">
            <button class="t-menu-item" (click)="selectAllImages(false)">
                Deselect All
            </button>
        </li>
        <li *ngIf="! forPrint && (gs.showSelect && (gs.imageGroup.get('imageSelection').value.includes(true)))">

            <div class="t-validation-wrap">
                <button class="t-menu-item" (click)="invalidi='is-invalid'" [ngClass]="invalidi"> Download
                    ({{dwonloadImageCt}})</button>

                <div class="t-validation-message" style="width:30vw;left:-13vw;font-size: 1.87em;top:+2vw">
                    <span>בחרת להוציא חומר הכולל מידע רפואי רגיש ממערכת מאובטחת , מרגע הורדה החומר אינו מוגן יותר אנא
                        הקפד שלא להשאירו בכונן או במיקום רשת נגיש לאנשים שאינם מורשים לצפות בחומר
                        <br>
                        <div style="display: flex; justify-content: space-between; margin-left: 1vw;margin-right: 1vw;">
                            <button (click)="gs.downloadImages();download=true;invalidi=''"
                                class="t-menu-item">אישור</button>
                            <button (click)="invalidi=''" class="t-menu-item">בטל</button>
                        </div>

                    </span>

                </div>
            </div>
        </li>
        <li *ngIf="! forPrint && gs.showSelect">
            <button class="t-menu-item" (click)="gs.showSelect = !gs.showSelect">
                Cancel
            </button>
        </li>
        </div>
        <div style="display: inline-flex; align-items: center;">
            <li *ngIf="! forPrint && ! gs.showSelect && ls.isCardio">
                <label style="margin-inline-end: 1em;">Gallary view</label>
                <select class="t-select t-field" style="background-color: aliceblue;" [(ngModel)]="view">
                    <option value="Timeline">Timeline</option>
                    <option value="Groups">By Type</option>
                </select>
            </li>
            <li *ngIf="!forPrint && !gs.showSelect && es.dicomStudyUID" class="adv-viewer-li">
                <button class="adv-viewer-btn" (click)="openInADV()" title="Open in Artisan DICOM Viewer">
                    <img src="../../assets/icons/artisan-viewer-white.svg" class="adv-viewer-icon" alt="" />
                    <span>Artisan Viewer</span>
                </button>
            </li>
        </div>
    </ul>
    <div class="h100 l-flex t-row t-boxMargin--spacebyPadding gallery-table" *ngIf="view =='Timeline'">
        <div class="l-fg1">
            <div class="h100 m-box l-fg1 gallery-still">
                <h2>
                    <i class="gallery-title-icon  icon-camera-still"></i>
                    Timeline
                </h2>
                <div class="scroller">

                    <div class="l-flex l-flex-w gallery-item-list" style="padding-bottom: 1.87em;">

                        <div class="gallery-item" *ngFor="let n of ' '.repeat(timelinect).split('');index as i">

                            <div class="gallery-item-in" style="width: 100%;" *ngIf="checkArray(gs.Timeline[i])">

                                <span (click)="open(i)" class="lb gallery-item-frame">

                                    <img [src]="_timeline[i].thumb" alt="" />

                                </span>
                                <textarea *ngIf="es.isGastro"
                                    style="background: none;border: none;margin: 3px;width: 95%;max-height: 1.5em;"
                                    [(ngModel)]="_timeline[i].text" (ngModelChange)="gs.saveText(i, _timeline[i].text)"
                                    [ngModelOptions]="{standalone: true}"></textarea>
                                <label *ngIf="forPrint || gs.showSelect" class="l-flex"
                                    style="justify-content: center;margin-bottom: 1%; margin-bottom: 2%;">
                                    <input type="checkbox" name="i" class="custom-check -sq" [value]="true"
                                        [formControlName]="i" />
                                    <i class="customInput-display"></i>
                                </label>

                            </div>
                            <ng-container *ngIf="! checkArray(gs.Timeline[i])">
                                <div class="h100 w100 gallery-videos">
                                    <div class="h100 frame">
                                        <div class="videoPlay">
                                            <div class="gallery-item" style="width: 100%;">
    
                                                <div class="gallery-item-in">
    
                                                    <span>
    
                                                        <img [src]="_timeline[i].thumb" alt="" />
                                                        <span (click)="openClip(i)">
                                                            <img src="../../assets/icons/play.svg" style="max-height: 2em ;padding-block-start: 0.5em;"/>
                                                        </span>
    
                                                    </span>
    
                                                </div>
    
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </ng-container>

                        </div>

                    </div>

                </div>
            </div>

        </div>

    </div>



    <div class="h100 l-flex t-row t-boxMargin--spacebyPadding gallery-table" *ngIf="view =='Groups'">

        <div class="l-fg1">

            <div class="h100 m-box l-fg1 gallery-still" [formGroup]="gs.imageGroup">

                <h2>
                    <i class="gallery-title-icon icon-camera-still"></i>
                    Images
                    <span *ngIf="dicomMediaLoading" class="dicom-loading-badge">
                        <span class="dicom-loading-spinner"></span>
                        Loading DICOM images…
                    </span>
                </h2>

                <div class="scroller">

                    <div class="l-flex l-flex-w gallery-item-list" formArrayName="imageSelection"
                        style="padding-bottom: 1.87em;">

                        <div class="gallery-item" style="width: 33.3%;" *ngFor="let n of ' '.repeat(imgct).split('');index as i">

                            <div class="gallery-item-in" style="max-width: 100%;">

                                <span (click)="open(i)" class="lb gallery-item-frame">

                                    <img [src]="_albums[i].thumb" alt="" />

                                </span>
                                <textarea *ngIf="!_albums[i].dicom"
                                    style="background: none;border: none;margin: 3px;width: 95%;max-height: 1.5em;"
                                    [(ngModel)]="_albums[i].text" (ngModelChange)="gs.saveText(i, _albums[i].text)"
                                    [ngModelOptions]="{standalone: true}"></textarea>
                                <label *ngIf="(forPrint || gs.showSelect) && !_albums[i].dicom" class="l-flex"
                                    style="justify-content: center;margin-bottom: 1%; margin-bottom: 2%;">
                                    <input type="checkbox" name="i" class="custom-check -sq" [value]="true"
                                        [formControlName]="i" />
                                    <i class="customInput-display"></i>
                                </label>
                                <label *ngIf="forPrint && _albums[i].dicom" class="l-flex"
                                    style="justify-content: center;margin-bottom: 1%; margin-bottom: 2%;">
                                    <input type="checkbox" class="custom-check -sq" [value]="true"
                                        [(ngModel)]="_albums[i].printChecked"
                                        (ngModelChange)="gs.saveDicom(_albums[i].dicomUid, $event, _albums[i].study, _albums[i].series)"
                                        [ngModelOptions]="{standalone: true}" />
                                    <i class="customInput-display"></i>
                                </label>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="h100 gallery-videos" *ngIf="! forPrint && ! gs.showSelect" [ngClass]="ls.isCardio ? 'w45': ''">

            <div class="h100 m-box">

                <h2>
                    <i class="gallery-title-icon icon-camera-video"></i>
                    Clips
                </h2>

                <div>
                    <!--class="scroller"-->

                    <div class="l-flex l-flex-w gallery-item-list gallery-videos-holder">
                        <div class="gallery-item" *ngFor="let n of ' '.repeat(clipct).split('');index as i" [ngClass]="ls.isCardio ? 'w33' :''">

                            <div class="gallery-item-in" [ngClass]="ls.isCardio ? 'cardioSizeImage' : ''">

                                <!-- <span (click)="openClip(i)" class="lb gallery-item-frame">

                                    <img [src]="_clips[i].thumb" alt="" />

                                </span> -->
                                <span (click)="openClip(i)">
                                    <img [src]="_clips[i].thumb" alt="" />
                                    <span>
                                        <img src="../../assets/icons/play.svg" style="max-height: 2em ;padding-block: 0.3em;"/>
                                    </span>
                                </span>


                            </div>

                        </div>
                    </div>

                </div>

            </div>

            <div class="h100 gallery-videos w100" *ngIf="! forPrint && ! gs.showSelect">

                <div class="h100 m-box">
    
                    <h2>
                        <i class="gallery-title-icon icon-pdf"></i>
                        Documents
                    </h2>
    
                    <div>
                        <!--class="scroller"-->
    
                        <div class="l-flex l-flex-w gallery-item-list gallery-videos-holder">
                            <div class="gallery-item w33" *ngFor="let n of ' '.repeat(pdfct).split('');index as i">
                                <div class="gallery-item-in cardioSizeImage">
                                    <h3 style="float: left;">{{i+1}}</h3>
    
                                    <span (click)="openPDF(i)">
                                        <img [src]="_pdfs[i].thumb" alt="" style="max-height: 9em;"/>
                                    </span>
    
                                </div>
    
                            </div>
                        </div>
    
                    </div>
    
                </div>
            </div>

            <div class="h100 m-box" *ngIf="! gs.showSelect && !ls.isCardio">

                <h2>
                    <i class="gallery-title-icon icon-camera-full"></i>
                    Full length recordings
                </h2>

                <div>
                    <!--class="scroller"-->

                    <div class="l-flex l-flex-w gallery-item-list gallery-videos-holder">
                        <div class="gallery-item" *ngFor="let n of ' '.repeat(fullct).split('');index as i">

                            <div class="gallery-item-in" (click)="openClip(i,true)">

                                <!-- <span (click)="openClip(i,true)" class="lb gallery-item-frame">

                                    <img alt="" />

                                </span> -->
                                <span >
                                    <img [src]="_fulls[i].thumb" alt="" />
                                    <span>
                                        <img src="../../assets/icons/play.svg" style="max-height: 2em ;padding-block: 0.3em;"/>
                                    </span>
                                </span>


                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>



    </div>
</section>
<div [ngClass]="ls.isCardio && view == 'Groups' ? 'videos-cardio' : 'videos'" *ngIf="showVid">
    <span (click)="showVid=false" style='float:right'><img src="../../assets/icons/x.svg" style='height:2em'></span>
    <video [src]="currentclip" autoplay="true" controls="true" loop="true" style="max-height:80vh;width: 45em;"></video>
</div>
<div class="modalback" *ngIf="showVid" (click)="showVid=false"></div>
<div *ngIf="isPDFLoading || pdfToShow != null" style="position:absolute;top:0">
    <button (click)="pdfToShow=null" class="save_patieont">Close</button>
    <embed *ngIf="!isPDFLoading && pdfToShow != null" [src]="pdfToShow" type="application/pdf"
                        style='position: relative;width:70vw;height:80vh;z-index:10'>
                    <img *ngIf="isPDFLoading" src="../../assets/images/Wedges.svg"
                        style='z-index:0;margin-left: auto;margin-right:auto;position: absolute;left: 0; right: 0;top: 40vh'>
</div>